import { render, staticRenderFns } from "./ShiftBatchIngredientsForm.vue?vue&type=template&id=5037efdb&"
import script from "./ShiftBatchIngredientsForm.vue?vue&type=script&lang=ts&"
export * from "./ShiftBatchIngredientsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports